// src/config.js
const isDev = process.env.NODE_ENV === 'development';

export const API_BASE = process.env.REACT_APP_API_BASE || (isDev
  ? 'http://localhost:8080'
  : 'https://api.vaultize.krydacloud.com');

export const APP_NAME = 'Vaultize';

// Centralized Contact Details (Synchronized with https://krydacloud.com/contact)
export const CONTACT_COMPANY = process.env.REACT_APP_CONTACT_COMPANY || 'Kryda Cloud Technologies Pvt. Ltd.';
export const CONTACT_ADDRESS = process.env.REACT_APP_CONTACT_ADDRESS || 'Hindon Vihar, Sector 49, Noida, UP 201301, India';
export const CONTACT_PHONE = process.env.REACT_APP_CONTACT_PHONE || '+91 79055 45978';
export const CONTACT_PHONE_HREF = process.env.REACT_APP_CONTACT_PHONE_HREF || 'tel:+917905545978';
export const CONTACT_WHATSAPP_HREF = process.env.REACT_APP_CONTACT_WHATSAPP_HREF || 'https://wa.me/917905545978';
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || 'support@krydacloud.com';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@krydacloud.com';
export const CONTACT_SLA = 'Guaranteed executive response within 4 business hours.';
export const CONTACT_MAP_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3516.006672853516!2d77.3734388!3d28.5577962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5f83161cf35%3A0x641c2ada0158eca8!2sHindon%20Vihar%2C%20Baraula%2C%20Sector%2049%2C%20Noida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin';
